export const NAME = 'search';

export const SEARCH_INPUT = 'SEARCH_INPUT';
export const SEARCH_CLEAR = 'SEARCH_CLEAR';



// WEBPACK FOOTER //
// ./src/services/search/constants.js